import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

// Import the routing file
import { AppRoutingModule } from './app-routing.module';

// Firestarter App Modules
import { CoreModule } from './core/core.module';
//import { UploadsModule } from './uploads/uploads.module';
import { SharedModule } from './shared/shared.module';
import { MainModule } from './main/main.module';
//import { NotesModule } from './notes/notes.module';
import { ToastyModule } from 'ng2-toasty';

// AngularFire2 Modules
import { AngularFireModule } from 'angularfire2';
//import { AngularFireStorageModule } from 'angularfire2/storage';
import { AngularFireAuthModule } from 'angularfire2/auth';

//import { AngularFireFunctionsModule } from 'angularfire2/functions';
import { AngularFireDatabaseModule } from 'angularfire2/database';

// See README for Firebase setup instructions
export const firebaseConfig = {
  apiKey: "AIzaSyCvbMIUO25rzKoh090eubB8qCWDwy3mp04",
  authDomain: "bandly-13dd5.firebaseapp.com",
  databaseURL: "https://bandly-13dd5.firebaseio.com/",
  storageBucket: "gs://bandly-13dd5.appspot.com",
  messagingSenderId: "142134069329",
  projectId: "bandly-13dd5"
};


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserTransferStateModule,
    ToastyModule,
    CoreModule,
    AppRoutingModule,
    SharedModule,
    //NotesModule,
    //UploadsModule,
    MainModule,
    AngularFireModule.initializeApp(firebaseConfig),
    //AngularFirestoreModule,
    AngularFireAuthModule,
    //AngularFireStorageModule,
    AngularFireDatabaseModule,
    //AngularFireFunctionsModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
